export default __webpack_public_path__ + "static/media/reporthelp-export.d5ca85ff.PNG";